import { lazy, useState } from 'react';

// project import
import Loadable from 'components/Loadable';
import MainLayout from 'layout/MainLayout';
import AuthGuard from 'utils/route-guard/AuthGuard';
import SwitchOrg from 'pages/auth/switch-org';

const SplashScreen = Loadable(lazy(() => import('layout/MainLayout/SplashScreen/SplashScreen')));

/*PROFESSIONAL PAGES ROUTING*/
const CompetitiveLandscape = Loadable(lazy(() => import('pages/CompetitiveLandscape/CompetitiveLandscape')));

/*DATA AUDIT PAGES ROUTING*/
const DataAuditReferenceTable = Loadable(lazy(() => import('pages/DataAuditReference/DataAuditReferenceTable')));
const AuditReport = Loadable(lazy(() => import('pages/DataAuditReference/AuditReport')));
const ProcedureCostByHospital = Loadable(lazy(() => import('pages/ProcedureCostByHospital/index')));
const DrgReferenceTable = Loadable(lazy(() => import('pages/DrgReferenceTable/DrgReferenceTable')));
const MaintenanceError = Loadable(lazy(() => import('pages/maintenance/404')));

/*FACILITY AND ANCILLARY ROUTING*/
const OverviewDrgCPT = Loadable(lazy(() => import('pages/OverviewDrgCPT/OverviewDrgCPT')));
const PayersPriceCompare = Loadable(lazy(() => import('pages/PayersPriceCompare/PayersPriceCompare')));
const FilteredDRGList = Loadable(lazy(() => import('pages/FilteredDRGList/FilteredDRGList')));
// const DRGCostBreakdown = Loadable(lazy(() => import('pages/DRGCostBreakdown/DRGCostBreakdown')));
const ProviderExtract = Loadable(lazy(() => import('pages/ProviderExtract/index')));
const HistoricalRequests = Loadable(lazy(() => import('pages/HistoricalRequests/HistoricalRequests')));
// const FacilityScorecard = Loadable(lazy(() => import('pages/facilityScorecard/index')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = () => {
  const [isSplashOpen, setisSplashOpen] = useState(true);
  const getSplashShow = localStorage.getItem('splashShow') || true;

  const routes = {
    path: '/',
    element: (
      <AuthGuard>
        <MainLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: '/',
        index: true,
        element:
          isSplashOpen && getSplashShow == true ? (
            <SplashScreen isSplashOpen={isSplashOpen} setisSplashOpen={setisSplashOpen} />
          ) : (
            <CompetitiveLandscape />
          )
      },
      {
        path: 'competitive-landscape',
        element: <CompetitiveLandscape />
      },
      {
        path: 'filtered-drg-list',
        element: <FilteredDRGList />
      },
      {
        path: 'payer-scorecard',
        element: <DataAuditReferenceTable />
      },
      {
        path: 'report-summary',
        element: <AuditReport />
      },
      {
        path: 'procedure-cost-by-hospital',
        element: <ProcedureCostByHospital />
      },
      {
        path: 'drg-ref-table',
        element: <DrgReferenceTable />
      },
      {
        path: '/switch-org',
        index: true,
        element: <SwitchOrg />
      },
      {
        path: 'top-drg',
        element: <OverviewDrgCPT />
      },
      {
        path: 'top-cpt',
        element: <OverviewDrgCPT />
      },
      {
        path: 'payer-price-comparison-CPT-HCPCS',
        element: <PayersPriceCompare />
      },
      {
        path: 'payers-price-compare-drg',
        element: <PayersPriceCompare />
      },
      {
        path: 'payers-price-compare-apc',
        element: <PayersPriceCompare />
      },
      {
        path: 'provider-CPT-HCPCS-data',
        element: <ProviderExtract />
      },
      {
        path: 'historical-requests',
        element: <HistoricalRequests />
      },
      // {
      //   path: 'facility-scorecard',
      //   element: <FacilityScorecard />
      // },
      {
        path: '/maintenance/404',
        element: <MaintenanceError />
      }
    ]
  };
  return {
    routes
  };
};

export default MainRoutes;
